import { constants, mediaQueryStyles } from "@newsela/angelou";

const { colors, breakpoints } = constants;
const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { lg, md, xs },
} = breakpoints;

const grey = colors.ui.neutral[500];
const greyDark = colors.ui.neutral[700];

export const rootCss = {
  alignItems: "center",
  color: greyDark,
  display: "flex",
  margin: "8px 8px 8px 0",
  padding: "8px 6px 8px 11px",

  [mediaQuery.downTo(lg)]: {
    color: grey,
  },

  [mediaQuery.between(xs, md)]: {
    width: "initial",
  },

  // Overriding an Angelou default that is cutting off the icon
  svg: {
    height: "unset !important",
  },
};

export const iconCss = {
  path: {
    stroke: greyDark,
  },

  [mediaQuery.between(xs, md)]: {
    path: {
      stroke: grey,
    },
  },
};

export const labelCss = {
  color: grey,
  display: "block",
  paddingRight: "5px",

  [mediaQuery.downTo(md)]: {
    display: "none",
  },

  [mediaQuery.upTo(xs)]: {
    display: "none",
  },
};
